import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { PurchaseContractSearchProvider } from './context/purchase-contract-search-context';
import { PurchaseContractSearchComponent } from './purchase-contract-search-component';

export function PurchaseContractSearchFactory() {
    return (
        <BaseLayoutFactory>
            <PurchaseContractSearchProvider>
                <PurchaseContractSearchComponent />
            </PurchaseContractSearchProvider>
        </BaseLayoutFactory>
    );
}
